const PROVIDER_PRETTY_NAMES: Record<string, string> = {
  'chili-piper': 'Chili Piper',
  'default': 'Default.com',
  'revenue-hero': 'RevenueHero',
  'calendly': 'Calendly',
  'tidycal': 'TidyCal',
  'cal-com': 'Cal.com',
  'hubspot-meetings': 'HubSpot Meetings',
};

const BOOKING_URL_KEYS = [
  'hubspot_meetings_url',
  'tidy_cal_url',
  'cal_com_url',
  'calendly_url',
] as const;

export function prettyCalendarProviderName(name: string): string {
  return PROVIDER_PRETTY_NAMES[name] || name.charAt(0).toUpperCase() + name.slice(1);
}

export function calendarBookingUrl(details?: Record<string, unknown> | null): string | null {
  if (!details || typeof details !== 'object') return null;
  for (const key of BOOKING_URL_KEYS) {
    const value = details[key];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return null;
}

export function calendarLinkLabel(details?: Record<string, unknown> | null): string | null {
  if (!details || typeof details !== 'object') return null;
  const named = details.link_name;
  if (typeof named === 'string' && named.trim()) {
    return named.trim();
  }
  const url = calendarBookingUrl(details);
  if (!url) return null;
  try {
    const parsed = new URL(url);
    const path = parsed.pathname.replace(/^\/|\/$/g, '');
    return path || parsed.hostname;
  } catch {
    return url;
  }
}

export function formatCalendarOptionLabel({
  providerName,
  userName,
  details,
}: {
  providerName: string;
  userName?: string | null;
  details?: Record<string, unknown> | null;
}): string {
  const provider = prettyCalendarProviderName(providerName);
  const link = calendarLinkLabel(details);
  if (userName && link) return `${userName} — ${link}`;
  if (userName) return `${userName} (${provider})`;
  if (link) return `${provider} — ${link}`;
  return provider;
}
